import { render, staticRenderFns } from "./ServicePointDetailLastTransactions.vue?vue&type=template&id=5066ae24&scoped=true&"
import script from "./ServicePointDetailLastTransactions.vue?vue&type=script&lang=ts&"
export * from "./ServicePointDetailLastTransactions.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointDetailLastTransactions.vue?vue&type=style&index=0&id=5066ae24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066ae24",
  null
  
)

export default component.exports